
import { useState } from "react";
import { Card } from "@material-ui/core";
import { Avatar, Box, Typography } from "@mui/material";
import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import api from "../../../../services/api";
import ShortNome from "../../../../utils/ShortNome";
import DateHora from "../../../../utils/dateHora";
import Editor from "../../../../ckeditor/editor";
import TextFormatado from "../../../../utils/TextFormatado";
import ButtonLeft from "../../../../utils/buttonLeft";
import InputDocUpload from "../../../../utils/inputFileUpload/inputDocUpload";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";


export default function ResponseFarmacovigilancia({ farmacovigilancia, userId, setUpdate }) {
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [respostaFarmacovigilancia, setRespostaFarmacovigilancia] = useState('')
    const [open, setOpen] = useState(false)

    async function HandleChangeFile(file, name) {
        setRespostaFarmacovigilancia((prevCadastro) => ({ ...prevCadastro, [name]: file }))
    }

    const sendResposta = async () => {
        setUpdate(false)
        setOpen(true)
        setMessageSuccess('')
        setMessageError('')

        const formData = new FormData();
        formData.append('resposta', respostaFarmacovigilancia?.conteudo);
        formData.append('anexoDespacho', respostaFarmacovigilancia?.anexo);
        formData.append('farmacoVigilanciaId', farmacovigilancia?._id);
        formData.append('userId', userId);

        // await api.patch('/farmaco-vigilancia/respond-processo', {resposta: respostaFarmacovigilancia?.conteudo, anexoDespacho: respostaFarmacovigilancia?.anexo, farmacoVigilanciaId: farmacovigilancia?._id, userId})
        await api.patch('/farmaco-vigilancia/respond-processo', formData)
            .then(response => {
                setOpen(false)
                setMessageSuccess('Resposta enviada com sucesso')

                // api.patch('/Farmacovigilancia/change-status', { id, userId, 'status': 'Concluído' })
                setUpdate(true)

                // window.setTimeout(() => {
                //     navigate(-1)
                // }, 5000);

            }).catch(error => {
                // console.log(error)
                setOpen(false)
                setMessageError(error.response.data.message)
            })
    }

    return (
        farmacovigilancia?.resposta ?
            <Card style={{ padding: 20, position: 'relative', marginTop: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={farmacovigilancia?.despachoPor?.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                    <Typography lineHeight={1} noWrap variant="body1">
                        <ShortNome nome={farmacovigilancia?.despachoPor?.dadosPessoais?.nome} />
                        <br />
                        <small><DateHora date={farmacovigilancia?.updatedAt} /></small>
                    </Typography>
                </div>

                <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Resposta a Notificação:</strong>  <TextFormatado texto={farmacovigilancia?.resposta ?? ''} /> </Typography>
                </Box>

                <embed
                    id="pdfIframeFarmacovigilanciaEsposta"
                    title={`PDF Viewer`}
                    src={[farmacovigilancia?.anexoDespacho]}
                    width="100%"
                    height="800px"
                    style={{ border: 'none' }}
                />
            </Card>
            :
            <Card style={{ padding: 20, position: 'relative', marginTop: 10 }}>
                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && <MessageError message={messageError} />}

                <HeaderGestorConfigs title={'Responder Notificação'} />
                <Editor
                    setEditorData={setRespostaFarmacovigilancia}
                    editorData={respostaFarmacovigilancia?.resposta}
                />

                {/* ANEXAR DOCUMENTOS COMPLEMENTARES */}
                <InputDocUpload
                    imputLigth={true}
                    fullWidth={true}
                    onFileSelect={HandleChangeFile}
                    inputName={'anexo'}
                    inputDescription={'Anexo do Despacho'}
                    inputTitle={'Adicionar anexo'}
                />

                <ButtonLeft
                    title={'Enviar Resposta'}
                    disabled={!respostaFarmacovigilancia?.conteudo || open}
                    funcao={sendResposta}
                    load={open}
                />
            </Card>
    )
}